import { NavigationContext } from '@layout/navigation/navigation';
import { AssetContext } from '@pages/Asset/Asset.query';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { getPermissionData, setAttr } from '@utils';
import { getProductValue } from '@utils/getProductValue';
import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import TextComponent from '@components/Text/Text';
import { Icon } from '@blueprintjs/core';
import { Container, RowButton } from './NoResources.styles';

const NoResources = () => {
  const { openAddResource, equipmentQuery } = useContext(AssetContext);
  const { role } = useContext(NavigationContext);

  const addPermission = getPermissionData({
    owner: true,
    action: 'add',
    role,
    type: 'Resource',
  });
  const equipment = equipmentQuery?.data;
  const { manufacturerId, productId } = getProductValue(equipment);

  const hasProduct = manufacturerId && productId;
  const isEnabled = addPermission.allowed && hasProduct;
  const [tooltipId] = useState(() => {
    return `add-resources-disabled-tooltip${Date.now()}`;
  });
  const { isDesktop } = useSelector(checkDevice());

  return (
    <Container>
      {isDesktop && (
        <RowButton
          className="new-icon"
          data-disabled={setAttr(!isEnabled)}
          data-tip={addPermission.message}
          data-for={tooltipId}
          onClick={() => {
            if (isEnabled) {
              openAddResource.set(true);
            }
          }}
        >
          <Icon icon="document" color="#1371fe" />
          <TextComponent text="b200" textColor="b401">
            Add your Resources
          </TextComponent>
        </RowButton>
      )}
      <TextComponent text="b200" textColor="n800" ta="center">
        You don&apos;t have any resources yet!
      </TextComponent>

      <TextComponent maw={251} text="p200" textColor="n800">
        Resources can be related to a manufacturer, a product or shown in all
        your assets.
      </TextComponent>
    </Container>
  );
};

export { NoResources };
